import { apiClient } from '../../core/api/client';
import type { VoiceMode } from './contracts';

export interface TtsCatalogModel {
  id: string;
  label: string;
  mode: VoiceMode;
  available: boolean;
}

export async function loadTtsCatalog(): Promise<TtsCatalogModel[]> {
  const result = await apiClient.get<{ models: TtsCatalogModel[] }>('/v1/tts/catalog');
  return result.models;
}
